// SECURITY ENHANCEMENT: This component protects routes from unauthorized access.
// It checks for a valid JWT and, if required, a specific user role.
// It centralizes access control logic instead of scattering it within each component.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode'; // Corrected import for jwt-decode

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const userString = localStorage.getItem('user');
  
  let user = null;
  let isTokenExpired = false;

  try {
    user = userString ? JSON.parse(userString) : null;
    console.log("ProtectedRoute: User object from localStorage:", user);
    console.log("ProtectedRoute: User role:", user?.role);


    // Check token expiration client-side
    if (token) {
      const decodedToken = jwt_decode(token); // Use jwt_decode as a function
      if (decodedToken.exp * 1000 < Date.now()) { // exp is in seconds, convert to ms
        isTokenExpired = true;
        console.warn("Client-side: Token expired. Forcing logout.");
      }
    }
  } catch (error) {
    console.error("Failed to parse user data or decode token from localStorage", error);
    // If user data is corrupt or token is invalid/malformed, treat as logged out
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    user = null;
    isTokenExpired = true; // Also treat as expired if parsing fails
  }

  // 1. Check for authentication or expired token
  if (!token || !user || isTokenExpired) {
    // Clear storage if token was just found to be expired client-side
    if (isTokenExpired) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    // Redirect them to the /auth page, but save the current location they were
    // trying to go to. This allows us to redirect them back after login.
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // 2. Check for role-based authorization
  // If allowedRoles are specified, the user's role must be included.
  if (allowedRoles && allowedRoles.length > 0) {
    if (!user.role || !allowedRoles.includes(user.role)) {
      // User is logged in but does not have the required role or role is missing.
      // Redirect to a "not authorized" page or the homepage.
      // Fallback to 'auth' if user.role is missing for dashboard path.
      const dashboardPath = `/${user.role || 'auth'}-dashboard`; 
      return <Navigate to={dashboardPath} replace />;
    }
  }

  // 3. If authenticated and authorized, render the child component
  return children;
};

export default ProtectedRoute;